/* XSTRAP advanced, option/SKU-aware variant galleries.
   ALT convention: "Customer-facing photo description # color_blue"
   or "# length_16ft", "# size_large", "# sku_X123-blue", "# variant_123".
   This script only enhances tagged galleries; untagged products are unchanged. */
(function () {
  'use strict';
  if (window.__xstrapVariantGalleryLoaded) return;
  window.__xstrapVariantGalleryLoaded = true;
  var schedules = typeof WeakMap !== 'undefined' ? new WeakMap() : null;
  function norm(s) { return String(s == null ? '' : s).trim().toLowerCase().replace(/\s+/g, ' '); }
  function readInfo(root) {
    var data = document.querySelector('script[data-xstrap-variant-gallery-map][data-section-id="' + root.getAttribute('data-section-id') + '"]');
    if (!data) return null;
    try { return JSON.parse(data.textContent); } catch (e) { return null; }
  }
  function selectedVariant(root, cfg, eventVariant) {
    if (eventVariant && eventVariant.id) {
      var fromEvent = (cfg.variants || []).find(function (v) { return String(v.id) === String(eventVariant.id); });
      if (fromEvent) return fromEvent;
    }
    var inputs = root.querySelectorAll('input[name="id"]');
    for (var i = 0; i < inputs.length; i++) {
      var value = inputs[i].value;
      var found = (cfg.variants || []).find(function (v) { return String(v.id) === String(value); });
      if (found) return found;
    }
    var fromUrl = new URLSearchParams(window.location.search).get('variant');
    var byUrl = (cfg.variants || []).find(function (v) { return String(v.id) === String(fromUrl); });
    return byUrl || (cfg.variants || []).find(function (v) { return String(v.id) === String(cfg.selected); }) || (cfg.variants || [])[0];
  }
  function mediaMatches(el, v, cfg) {
    var group = norm(el.dataset.groupName).replace(/[\s-]+/g, '_');
    var value = norm(el.dataset.groupValue);
    if (!group) return null;
    if (group === 'sku') return norm(v.sku) === value;
    if (group === 'variant' || group === 'variant_id') return String(v.id) === value;
    var options = cfg.options || [];
    for (var i = 0; i < options.length; i++) {
      if (norm(options[i]).replace(/[\s-]+/g, '_') === group) return norm((v.values || [])[i]) === value;
    }
    return null; // Not a recognized option; treat as shared instead of hiding.
  }
  function apply(root, evVariant) {
    var cfg = readInfo(root);
    var gallery = root.querySelector('.product-gallery');
    if (!cfg || !gallery) return;
    var v = selectedVariant(root, cfg, evVariant);
    if (!v) return;
    var thumbnails = Array.prototype.slice.call(gallery.querySelectorAll('.product-gallery__thumbnail'));
    var carouselItems = Array.prototype.slice.call(gallery.querySelectorAll('.product-gallery__carousel-item'));
    var recognized = thumbnails.concat(carouselItems).filter(function (el) { return mediaMatches(el, v, cfg) !== null; });
    if (!recognized.length) return; // All existing media remain untouched.
    var anyMatches = recognized.some(function (el) { return mediaMatches(el, v, cfg) === true; });
    // Do not blank the gallery if this option/SKU lacks its own images.
    if (!anyMatches) {
      thumbnails.concat(carouselItems).forEach(function (el) { el.classList.remove('xvg-filtered'); });
      return;
    }
    function shouldHide(el) {
      var matches = mediaMatches(el, v, cfg);
      return matches === false || (matches === null && cfg.sharedImages === false);
    }
    thumbnails.concat(carouselItems).forEach(function (el) {
      el.classList.toggle('xvg-filtered', shouldHide(el));
    });
    if (cfg.autoFirstImage === false) return;
    var selectedThumb = gallery.querySelector('.product-gallery__thumbnail.is-nav-selected:not(.xvg-filtered):not(.is-filtered)');
    if (selectedThumb) return;
    var first = thumbnails.find(function (el) { return !el.classList.contains('xvg-filtered') && !el.classList.contains('is-filtered') && mediaMatches(el,v,cfg) === true; })
      || thumbnails.find(function (el) { return !el.classList.contains('xvg-filtered') && !el.classList.contains('is-filtered'); });
    if (first && !first.classList.contains('is-nav-selected')) first.click();
  }
  function schedule(root, variant) {
    if (schedules) {
      var old = schedules.get(root);
      if (old) cancelAnimationFrame(old);
      var rid = requestAnimationFrame(function () {
        schedules.delete(root);
        apply(root, variant);
      });
      schedules.set(root, rid);
    } else {
      requestAnimationFrame(function () { apply(root, variant); });
    }
  }
  function setup(root) {
    if (root.dataset.xvgInitialized === 'true') return;
    root.dataset.xvgInitialized = 'true';
    // Do not respond to pointer hover, raw clicks, or DOM mutations here.
    // Those events can run before the native variant-picker has committed the new ID,
    // making old and new gallery selections fight each other.
    // The native picker may commit a new variant ID after its input change event.
    // Wait until the next frame, then read the committed hidden ID; never select on hover.
    root.addEventListener('change', function (event) {
      if (!event.target.closest('variant-picker')) return;
      schedule(root);
    });
    window.addEventListener('popstate', function () { schedule(root); });
    schedule(root);
  }
  function init() {
    document.querySelectorAll('.xstrap-product-redesign[data-xstrap-variant-gallery="true"]').forEach(setup);
  }
  document.addEventListener('variant:changed', function (event) {
    var root = event.target && event.target.closest ? event.target.closest('.xstrap-product-redesign') : null;
    var v = event.detail && (event.detail.variant || event.detail);
    if (root) schedule(root, v);
    else document.querySelectorAll('.xstrap-product-redesign[data-xstrap-variant-gallery="true"]').forEach(function (r) { schedule(r, v); });
  });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();